import { render, staticRenderFns } from "./QuestionarioForm.vue?vue&type=template&id=6b80a3c8&scoped=true"
import script from "./QuestionarioForm.vue?vue&type=script&lang=js"
export * from "./QuestionarioForm.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioForm.vue?vue&type=style&index=0&id=6b80a3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b80a3c8",
  null
  
)

export default component.exports